import { default as campus } from './campus/routes'

export default [
    ...campus
]